import React, { useState, useEffect } from "react";
import IntroEngine from "./IntroEngine";

interface Props {
  children: React.ReactNode;
}

const IntroProvider: React.FC<Props> = ({ children }) => {
  // 1️⃣ التحقق من الجلسة فوراً عند تهيئة الـ State لمنع وميض الـ Intro
  const [finished, setFinished] = useState(() => {
    if (typeof window !== "undefined") {
      return sessionStorage.getItem("introWatched") === "true";
    }
    return false;
  });

  // إذا تم مشاهدة الانترو سابقاً، نعتبر التطبيق جاهزاً فوراً بدون تأخير
  const [isAppReady, setIsAppReady] = useState(() => {
    if (typeof window !== "undefined") {
      return sessionStorage.getItem("introWatched") === "true";
    }
    return false;
  });

  useEffect(() => {
    // إذا كان الانترو قد انتهى بالفعل من زيارة سابقة، لا داعي لتنفيذ مستمعي الأحداث
    if (finished) return;

    const handlePageLoad = () => {
      setTimeout(() => setIsAppReady(true), 1200); 
    };

    if (document.readyState === "complete") {
      handlePageLoad();
    } else {
      window.addEventListener("load", handlePageLoad);
      return () => window.removeEventListener("load", handlePageLoad);
    }
  }, [finished]);

  // دالة تُستدعى عند اكتمال أنيميشن GSAP بنجاح
  const handleIntroComplete = () => {
    sessionStorage.setItem("introWatched", "true"); // 2️⃣ حفظ الراية في المتصفح للزيارات القادمة
    setFinished(true);
  };

  return (
    <>
      {/* إذا شاهد المستخدم الانترو سابقاً، ستكون الظاهرية 1 فوراً وبدون وسم الـ Transition */}
      <div style={{ opacity: isAppReady ? 1 : 0, transition: finished ? "none" : "opacity 0.5s ease" }}>
        {children}
      </div>

      {!finished && (
        <IntroEngine 
          isAppReady={isAppReady} 
          onComplete={handleIntroComplete} // 3️⃣ تمرير الدالة المحدثة التي تحفظ الجلسة
        />
      )}
    </>
  );
};

export default IntroProvider;
